__turbopack_context__.v({
  "actions": "SuccessView-module-scss-module__hG5IVq__actions",
  "content": "SuccessView-module-scss-module__hG5IVq__content",
  "iconCircle": "SuccessView-module-scss-module__hG5IVq__iconCircle",
  "root": "SuccessView-module-scss-module__hG5IVq__root",
});
